export { default } from "./VideoPlayer.vue"


// WEBPACK FOOTER //
// ./src/components/video/index.js